export const TRADITION_AUCTION_CREATE_PAGE_PATH = '/auction/tradition/create'

export const TRADITION_AUCTION_LIST_PAGE_PATH = '/auction/tradition/list'
